import { DescribeNodeType } from '~/scenes/Automation/Flows/Actions/util/descriptionStandards';

const describeAppZapierNewCondition = (): DescribeNodeType =>
  'een nieuw Zapier koppeling binnen komt';

export default describeAppZapierNewCondition;
